import type { InjectionKey } from 'vue'
import type { CustomerDataService } from '@/types/customer-data-service'

export const TYPES = {
  CUSTOMER_DATA_SERVICE: Symbol('CustomerDataService') as InjectionKey<CustomerDataService>,
}
